/**
 * Created by francesco on 30/10/17.
 */
import {NgModule} from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {EmptyRedirectComponent} from './components/empty-redirect/empty-redirect.component';
import {FooterComponent} from './components/footer/footer.component';
import {LogoutDialogComponent} from './components/logout-dialog/logout-dialog.component';
import {RootComponent} from './components/root/root.component';
import {CoreComponent} from './components/core/core.component';
import {LoginComponent} from './components/login/login.component';
import {LoginRedirectComponent} from './components/login-redirect/login-redirect.component';
import { CoronavirusDialogComponent } from './components/coronavirus-dialog/coronavirus-dialog.component';
import { TranslatePipe } from '@shared/pipes/translate.pipe';

@NgModule({
	imports: [
		SharedModule,
	],
	declarations: [
		EmptyRedirectComponent,
		FooterComponent,
		LogoutDialogComponent,
		RootComponent,
		CoreComponent,
		LoginComponent,
		LoginRedirectComponent,
		CoronavirusDialogComponent
	],
	exports: [
		EmptyRedirectComponent,
		FooterComponent,
		LogoutDialogComponent,
		RootComponent,
		CoreComponent,
		LoginComponent,
		LoginRedirectComponent
	],
	providers: [
		TranslatePipe
	],
	entryComponents: [
		LogoutDialogComponent,
		CoronavirusDialogComponent
	],
})

export class CoreModule { }
